import React, { useState } from 'react';
import { Handle } from 'reactflow';

const CBCMaster = ({ data = {} }) => {
  const { 
    cbcAprobado = false,
    onToggleCbc,
    materiasAprobadas = 0,
    materiasCursando = 0,
    totalMaterias = 6
  } = data;

  const [showDetail, setShowDetail] = useState(false);
  const [isHovered, setIsHovered] = useState(false);

  const handleToggleCbc = (e) => {
    e.stopPropagation();
    if (onToggleCbc && typeof onToggleCbc === 'function') {
      onToggleCbc();
    }
  };

  const handleToggleDetail = (e) => {
    e.stopPropagation();
    setShowDetail(!showDetail);
  };

  const getStatusColor = () => {
    return cbcAprobado ? 'var(--success-color)' : 'var(--error-color)';
  };

  const getStatusText = () => {
    return cbcAprobado ? 'CBC APROBADO' : 'CBC PENDIENTE';
  };

  const getStatusIcon = () => {
    return cbcAprobado ? '✅' : '📚';
  };

  return (
    <div 
      className="cbc-master" 
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      style={{
        position: 'relative',
        minWidth: '320px',
        padding: '24px',
        border: `4px solid ${getStatusColor()}`,
        borderRadius: '20px',
        backgroundColor: cbcAprobado ? 
          'linear-gradient(135deg, rgba(76, 175, 80, 0.1), rgba(76, 175, 80, 0.05))' : 
          'linear-gradient(135deg, rgba(220, 53, 69, 0.1), rgba(220, 53, 69, 0.05))',
        background: cbcAprobado ? 
          'linear-gradient(135deg, rgba(76, 175, 80, 0.1), rgba(76, 175, 80, 0.05))' : 
          'linear-gradient(135deg, rgba(220, 53, 69, 0.1), rgba(220, 53, 69, 0.05))',
        boxShadow: isHovered ? 
          `0 16px 48px ${cbcAprobado ? 'rgba(76, 175, 80, 0.4)' : 'rgba(220, 53, 69, 0.3)'}` : 
          `0 8px 32px ${cbcAprobado ? 'rgba(76, 175, 80, 0.3)' : 'rgba(220, 53, 69, 0.2)'}`,
        transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
        cursor: 'default',
        transform: isHovered ? 'translateY(-4px) scale(1.02)' : 'translateY(0) scale(1)',
      }}
    >
      <Handle type="source" position="right" />
      
      <div style={{ textAlign: 'center' }}>
        {/* Título principal */}
        <div style={{ 
          marginBottom: '20px'
        }}>
          <h3 style={{ 
            margin: 0, 
            color: getStatusColor(), 
            fontSize: '1.4em',
            fontWeight: '700',
            textAlign: 'center',
            textShadow: `0 2px 4px ${cbcAprobado ? 'rgba(76, 175, 80, 0.3)' : 'rgba(220, 53, 69, 0.3)'}`,
            letterSpacing: '0.02em'
          }}>
            {getStatusIcon()} Ciclo Básico Común
          </h3>
        </div>
        
        {/* Checkbox principal - MÁS PROMINENTE */}
        <div 
          onClick={handleToggleCbc}
          style={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: '16px',
            marginBottom: '20px',
            padding: '20px',
            backgroundColor: cbcAprobado ? 'rgba(76, 175, 80, 0.15)' : 'rgba(220, 53, 69, 0.15)',
            borderRadius: '16px',
            border: `3px solid ${getStatusColor()}`,
            cursor: 'pointer',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            transform: 'scale(1)',
            boxShadow: `0 4px 16px ${cbcAprobado ? 'rgba(76, 175, 80, 0.3)' : 'rgba(220, 53, 69, 0.3)'}`,
          }}
          onMouseEnter={(e) => {
            e.target.style.transform = 'scale(1.03)';
            e.target.style.boxShadow = `0 8px 24px ${cbcAprobado ? 'rgba(76, 175, 80, 0.4)' : 'rgba(220, 53, 69, 0.4)'}`;
          }}
          onMouseLeave={(e) => {
            e.target.style.transform = 'scale(1)';
            e.target.style.boxShadow = `0 4px 16px ${cbcAprobado ? 'rgba(76, 175, 80, 0.3)' : 'rgba(220, 53, 69, 0.3)'}`;
          }}
        >
          <input
            type="checkbox"
            checked={cbcAprobado}
            onChange={handleToggleCbc}
            style={{
              width: '28px',
              height: '28px',
              cursor: 'pointer',
              accentColor: 'var(--success-color)',
              transform: 'scale(1.3)'
            }}
            id="cbc-checkbox"
          />
          <label 
            htmlFor="cbc-checkbox"
            style={{
              fontSize: '1.3em',
              fontWeight: '700',
              color: 'var(--text-primary)',
              cursor: 'pointer',
              userSelect: 'none',
              letterSpacing: '0.02em'
            }}
          >
            {getStatusText()}
          </label>
        </div>

        {/* Estado actual - MÁS VISIBLE */}
        <div style={{
          fontSize: '1.2em',
          color: getStatusColor(),
          fontWeight: '700',
          marginBottom: '16px',
          padding: '12px',
          backgroundColor: 'var(--bg-primary)',
          borderRadius: '12px',
          border: `2px solid ${getStatusColor()}`,
          boxShadow: 'var(--shadow-small)'
        }}>
          {cbcAprobado ? '✅ APROBADO' : '❌ PENDIENTE'}
        </div>

        {/* Mensaje de ayuda principal */}
        <div style={{
          fontSize: '0.95em',
          color: 'var(--text-primary)',
          fontWeight: '500',
          marginBottom: '16px',
          padding: '16px',
          backgroundColor: 'var(--bg-primary)',
          borderRadius: '12px',
          border: '1px solid var(--border-color)',
          textAlign: 'center',
          lineHeight: '1.4',
          boxShadow: 'var(--shadow-small)'
        }}>
          {cbcAprobado 
            ? '🎉 ¡Perfecto! Todas las materias están desbloqueadas'
            : '⚠️ Marca el checkbox para desbloquear el plan de estudios'
          }
        </div>

        {/* Botón de detalle - más discreto */}
        <button
          onClick={handleToggleDetail}
          style={{
            padding: '10px 20px',
            fontSize: '0.9em',
            backgroundColor: 'transparent',
            color: 'var(--text-secondary)',
            border: '2px solid var(--border-color)',
            borderRadius: '24px',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            marginBottom: showDetail ? '16px' : '0',
            fontWeight: '500'
          }}
          onMouseOver={(e) => {
            e.target.style.borderColor = 'var(--accent-color)';
            e.target.style.color = 'var(--accent-color)';
            e.target.style.backgroundColor = 'rgba(33, 150, 243, 0.1)';
          }}
          onMouseOut={(e) => {
            e.target.style.borderColor = 'var(--border-color)';
            e.target.style.color = 'var(--text-secondary)';
            e.target.style.backgroundColor = 'transparent';
          }}
        >
          {showDetail ? '🔼 Ocultar' : '🔽 Ver progreso detallado'}
        </button>

        {/* Detalle expandible - más compacto */}
        {showDetail && (
          <div style={{
            backgroundColor: 'var(--bg-hover)',
            padding: '16px',
            borderRadius: '12px',
            fontSize: '0.9em',
            textAlign: 'center',
            border: '1px solid var(--border-color)',
            boxShadow: 'var(--shadow-small)',
            opacity: 1,
            transform: 'translateY(0)',
            transition: 'all 0.3s ease-out'
          }}>
            <div style={{ marginBottom: '12px', fontWeight: '600', color: 'var(--text-primary)' }}>
              📊 Progreso del CBC
            </div>
            
            <div style={{ marginBottom: '12px', fontSize: '1.1em', fontWeight: '500' }}>
              Aprobadas: <span style={{ color: getStatusColor(), fontWeight: '700' }}>{materiasAprobadas}/{totalMaterias}</span>
              {materiasCursando > 0 && ` • Cursando: <span style={{ color: 'var(--status-cursando-border)', fontWeight: '700' }}>${materiasCursando}</span>`}
            </div>
            
            <div style={{
              width: '100%',
              height: '12px',
              backgroundColor: 'var(--bg-primary)',
              borderRadius: '6px',
              overflow: 'hidden',
              marginBottom: '12px',
              boxShadow: 'inset 0 2px 4px rgba(0,0,0,0.1)'
            }}>
              <div style={{
                width: `${(materiasAprobadas / totalMaterias) * 100}%`,
                height: '100%',
                background: `linear-gradient(90deg, ${getStatusColor()}, ${cbcAprobado ? 'var(--success-color)' : 'var(--error-color)'})`,
                transition: 'width 0.5s ease',
                borderRadius: '6px'
              }} />
            </div>
            
            <div style={{
              fontSize: '0.8em',
              color: 'var(--text-muted)',
              fontStyle: 'italic'
            }}>
              Este es solo el progreso real de tus materias CBC
            </div>
          </div>
        )}
      </div>
      
      <Handle type="target" position="left" />
      

    </div>
  );
};

export default CBCMaster; 